<ng-template #templateButton>
  <button
    [ngClass]="['segmented-option', 'segmented-option-' + size]"
    [disabled]="disabled"
    [class.active]="active"
    (click)="select.emit()"
  >
    <span *ngIf="icon && !dsIcon" class="material-symbols-outlined icon">{{ icon }}</span>
    <ds-icon *ngIf="dsIcon" [icon]="dsIcon" class="icon"></ds-icon>
    <span class="label">{{ label }}</span>
  </button>
</ng-template>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
